import app_2 from '@/public/features/time_tracking/Frame-1171279152.webp';
import bg from '@/public/features/time_tracking/Main.webp';

const intro = {
  tag: '',
  description: `Whether you're managing field workers or office staff, our time-tracking system ensures precise and reliable data. Accurately monitor your team's work hours, travel time, and job duration to ensure efficiency and accountability.`,
  imageSrc: bg.src,
  image: bg,
  first_title: 'Track employee hours accurately\xa0and effortlessly',
  second_title: ' with\xa0our\xa0Employee Time\xa0Tracking',
};

const blog = {
  title: 'Our Blog',
  description: `Dive into a wealth of insights tailored to your industry with Orcatec's blog, your go-to resource 
for the latest trends and tips in service scheduling software free`,
};

const bookDemo = {
  title: `Book a Free Demo`,
  description: `Book a free demo to unlock the full potential of our software for HVAC contractors! Orcatec team is here to guide you. Fill out the form below to receive expert consultation. Don’t miss this opportunity to transform your HVAC business with Orcatec's cutting-edge solutions, specially designed for HVAC contractors!`,
};

const fullArticle2 = {
  image: {
    path: app_2,
    alt: `What is Employee Time Tracking?`,
  },
  title: `What is Employee Time Tracking?`,
  description: `Employee time tracking is a vital tool for managing your workforce, providing detailed insights into travel time, job duration, and overall work hours. This feature helps you improve productivity, reduce time wastage, and ensure accurate payroll processing.`,
  item: [
    {
      title: 'Detailed time overview',
      description: `Gain a comprehensive view of your employees' travel time and time spent on each job. Our system provides accurate and detailed reports, helping you analyze and optimize work schedules.`,
    },
    {
      title: 'GPS-enabled clock-In',
      description:
        'Ensure accurate clock-ins with GPS verification. Employees can only clock in when location services are enabled on their mobile devices, ensuring that work hours are logged only when they are at the job site. This feature is available on both Android and iOS apps.',
    },

    {
      title: 'Time card reports',
      description: `Generate detailed reports on employee time cards, providing you with valuable data for payroll and performance analysis. Easily track work hours, overtime, and overall productivity with our comprehensive reporting tools.`,
    },
  ],
};

export { blog, bookDemo, fullArticle2, intro };
